export default __webpack_public_path__ + "static/werkblad-35b44f49b5ad11c10876c2ebec08f083.jpg";